import React, { useState, useEffect } from "react";
import "./UserProfilePanel.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import MailIcon from "../../Components/MailIcon/MailIcon";
import Help from "../../Components/Help/Help";
import Alert from "../../Components/Alert/Alert";
import Coins from "../../Components/Coins/Coins";
import BottomBar from "../../Components/BottomBar/BottomBar";
import userPanelHelp from "./userPanelHelp";
import Profile from "../../Components/Profile/Profile";
import Calendar from "../../Components/Calendar/Calendar";
import Axios from "axios";
import { useAuth } from "../../AuthContext";
import useUnCompleted from "../../Hooks/useUnCompleted";
// import usePlansForms from "../../Hooks/usePlansForms";
import useMainProfile from "../../Hooks/useMainProfile";
import useCalorie from "../../Hooks/useCalorie";
import CircularProgressBar from "../../Components/CircularProgressBar/CircularProgressBar";
import CourseFormModal from "../../Components/CourseFormModal/CourseFormModal";
import WaterModal from "../../Components/WaterModal/WaterModal";
import Body from "../../Components/Body/Body";
import Loading from "../../Components/Loading/Loading";
import useCheckForms from "../../Hooks/useCheckUnForms";
import { useBaseUrl } from "../../ApiContext";

export default function UserProfilePanel() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl()
  const navigate = useNavigate();
  const { dietForms, exerciseForms } = useUnCompleted(userToken);
  // const { currentDietPlans, currentExercisePlans } = usePlansForms(userToken);
  const [selectedDate, setSelectedDate] = useState(null);
  const { calorieData, setCalorieData } = useCalorie(userToken, selectedDate);
  const { userMainData } = useMainProfile(userToken);
  const [showFormModal, setShowFormModal] = useState(false);
  const [modalText, setModalText] = useState(false);
  const { medicalFormId, modalLabel } = useCheckForms(
    dietForms,
    exerciseForms,
    setShowFormModal,
    setModalText
  );
  const location = useLocation();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [showWaterModal, setShowWaterModal] = useState(false);
  const [waterPercent, setWaterPercent] = useState(0);
  const [sessions, setSessions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCalorie = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/calorie/${selectedDate}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        console.log(response.data);
      } catch (error) {
        console.log("Error during getting new message count", error);
      }
    };

    const fetchWater = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/water/${selectedDate}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        const milliliter =
          response.data.litre * 1000 + response.data.millilitre;
        const baseMilliliter = milliliter / 150;
        const baseUnitCount = baseMilliliter / 8;
        const percent = baseUnitCount * 100;
        const dailyWaterPercent = Math.round(percent);
        setWaterPercent(dailyWaterPercent);
      } catch (error) {
        console.log("Error during getting new message count", error);
      }
    };
    const fetchSessions = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/main_page/session/${selectedDate}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        console.log(response.data);
      } catch (error) {
        console.log("Error getting new message count request", error);
      }
    };
    if (selectedDate) {
      fetchCalorie();
      fetchSessions();
      fetchWater();
    }
  }, [baseUrl, selectedDate, showAlert]);

  useEffect(() => {
    const fetchReportSessions = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/profile/session/${selectedDate}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setSessions(response.data.sessions);
        setIsLoading(false);
      } catch (error) {
        console.log("Error during getting profile sessions", error);
      }
    };
    if (userToken && selectedDate) {
      fetchReportSessions();
    }
  }, [baseUrl, userToken, selectedDate]);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const showModalHandler = () => {
    setShowQuestionModal(true);
  };

  const handleClose = () => {
    setShowQuestionModal(false);
  };

  const showAlertHandler = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("به زودی");
  };

  const showWaterHandler = () => {
    setShowWaterModal(true);
  };

  const saveWaterDataHandler = () => {
    setShowWaterModal(false);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("ذخیره شد");
  };

  const handleDateSelection = (date) => {
    setSelectedDate(date);
  };

  const hideFormModal = () => {
    setShowFormModal(false);
  };

  const openCharts = () => {
    navigate("/charts", { state: { selectedDate: selectedDate } });
  };

  const handleReportAlert = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("مجاز نیست");
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <div className="userPanelHeaderRight centeredFlex">
              <MailIcon loc={location.pathname} />
              <Coins onShowAlert={showAlertHandler} />
            </div>
            <div className="userPanelHeaderLeft centeredFlex">
              <Help
                showQuestionModal={showQuestionModal}
                onShow={showModalHandler}
                onHide={handleClose}
                data={userPanelHelp}
              />
              <img
                src="/images/ic_menu.svg"
                alt="menu"
                className="menuIcon"
                onClick={hamburgerMenuHandler}
              />
            </div>
          </div>
          <div className="userPanelContent scroll">
            <Profile usedIn="userPanel" onShowAlert={handleReportAlert} />
            <Calendar onDateSelect={handleDateSelection} />
            <div className="profileSessionsWrapper centeredFlex horizontalBorder">
              {isLoading ? (
                <Loading />
              ) : (
                <div
                  className={`profileSessions centeredFlex ${
                    sessions.length > 0 ? "scroll" : ""
                  }`}
                  style={
                    sessions.length > 0
                      ? { justifyContent: "flex-start" }
                      : { justifyContent: "center" }
                  }
                >
                  {sessions.length > 0 ? (
                    sessions.map((session) => (
                      <div
                        key={session.id}
                        className="profileSession"
                        style={
                          session.product.type === "FITNESS"
                            ? { backgroundColor: "#FF4545" }
                            : session.product.type === "YOGA"
                            ? { backgroundColor: "#4AA366" }
                            : session.product.type === "PILATES"
                            ? { backgroundColor: "#FF842C" }
                            : { backgroundColor: "#94CDFD" }
                        }
                      >
                        <span className="profileSessionName">
                        {session.product.name}
                        </span>
                        <span className="profileSessionTime">
                          {session.date.time}
                        </span>
                        <span className="profileSessionDate">
                          {session.date.day} {session.date.month}
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className="userPanelNotFound centeredFlex">
                      <span className="sessionNotFound">جلسه ای یافت نشد</span>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="myBody">
              <div className="myBodyRight">
                <Link
                  to="/calorieCounter"
                  className="myBodyCalories link horizontalBorder centeredFlex"
                >
                  <div className="myBodyCaloriesRight centeredFlex">
                    <img
                      src="/images/rightPolygon.svg"
                      alt="right polygon icon"
                      className="myBodyPolygonIcon"
                    />
                    <CircularProgressBar
                      percentage={
                        (calorieData.consumed_calorie /
                          calorieData.total_calorie) *
                          100 <=
                        100
                          ? Math.floor(
                              (calorieData.consumed_calorie /
                                calorieData.total_calorie) *
                                100
                            )
                          : (calorieData.consumed_calorie /
                              calorieData.total_calorie) *
                              100 >
                            100
                          ? 100
                          : 0
                      }
                    />
                  </div>
                  <span className="calMarginLeft centeredFlex">cal</span>
                  <span className="centeredFlex">
                    {calorieData.consumed_calorie
                      ? calorieData.consumed_calorie.toFixed(1)
                      : 0}
                  </span>
                  <div className="wheatIconWrapper centeredFlex">
                    <img
                      src="/images/wheat.svg"
                      alt="wheat icon"
                      className="myBodyWheatIcon"
                    />
                  </div>
                </Link>
                <div className="myBodyExcercise horizontalBorder centeredFlex">
                  <div className="myBodyWeightIcons centeredFlex">
                    <img
                      src="/images/smoothWeight.svg"
                      alt="weight icon"
                      className="smoothWeightIcon"
                    />
                    <img
                      src="/images/crookedWeight.svg"
                      alt="weight icon"
                      className="crookedWeightIcon"
                    />
                  </div>
                  <span className="centeredFlex">cal</span>
                  <span className="centeredFlex">0</span>
                  <div className="myBodyFlameWrapper centeredFlex">
                    <img
                      src="/images/flame.svg"
                      alt="flame"
                      className="myBodyFlameIcon"
                    />
                  </div>
                </div>
                <div className="myBodyWalking horizontalBorder centeredFlex">
                  <div className="myBodyWalkingRight centeredFlex">
                    <img
                      src="/images/rightPolygon.svg"
                      alt="right polygon icon"
                      className="myBodyPolygonIcon"
                    />
                    <div>
                      <img
                        src="/images/pulse.svg"
                        alt="pulse icon"
                        className="pulseIcon"
                      />
                    </div>
                  </div>
                  <span className="centeredFlex">Km</span>
                  <span className="centeredFlex">0</span>
                  <div className="footIconWrapper centeredFlex">
                    <img
                      src="/images/foot.svg"
                      alt="foot icon"
                      className="myBodyFootIcon"
                    />
                  </div>
                </div>
                <div className="myBodyBottom centeredFlex">
                  <div onClick={openCharts} className="odometerWrapper">
                    <img
                      src="/images/odometer.svg"
                      alt="odometer icon"
                      className="odometerIcon"
                    />
                    <span>
                      {userMainData.weight
                        ? Math.floor(userMainData.weight)
                        : 0}{" "}
                      kg
                    </span>
                    <img
                      src="/images/addBtn.svg"
                      alt="add button icon"
                      className="addBtnIcon"
                    />
                  </div>
                  <div className="waterDropWrapper" onClick={showWaterHandler}>
                    <img
                      src="/images/waterDrop.svg"
                      alt="water drop icon"
                      className="waterDropIcon"
                    />
                    <span>{waterPercent}%</span>
                    <img
                      src="/images/addBtn.svg"
                      alt="add button icon"
                      className="addBtnIcon"
                    />
                  </div>
                </div>
              </div>
              <Body userData={userMainData} />
            </div>
          </div>
          <Alert alertText={alertText} showAlert={showAlert} />
          {showWaterModal && (
            <WaterModal
              setShowWaterModal={setShowWaterModal}
              onSaveAlert={saveWaterDataHandler}
              date={selectedDate}
            />
          )}
          <CourseFormModal
            show={showFormModal}
            onHandleHide={hideFormModal}
            btnText="تکمیل فرم"
            body={modalText}
            label={modalLabel}
            id={medicalFormId}
          />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
